import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import AttributeCobrandSettings from "./AttributeCobrandSettings/AttributeCobrandSettings";

const QuestionDbPage = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route
        path={`${path}/attribute-cobrand-settings`}
        component={AttributeCobrandSettings}
      />
    </Switch>
  );
};

export default QuestionDbPage;
